export default {
    OPEN_WIDGET: {type: 200},
    SEND_TOKEN: {type: 201},
    GET_TOKEN: {type: 202},
    SEND_URL: {type: 203}
};
